import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import makeStagedProgressBarStyling from './makeStagedProgressBarStyling';
import { StageStatus } from './StagedProgressBar.helpers';

const StagedProgressBar = ({ stages = [] }) => {
  const theme = useTheme();
  const styling = makeStagedProgressBarStyling({ theme });
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (!stages || stages.length === 0) return null;

  const currentStage = stages.find(
    (stage) => stage.status === StageStatus.CURRENT
  );

  return (
    <div className="staged-progress-wrapper" style={styling.progressWrapper}>
      {isDesktop ? (
        <div className="labels-container" style={styling.labelsContainer}>
          {stages.map((stage, index) => (
            <div
              key={`label-${stage.id}`}
              className="stage-label"
              style={styling.stageLabel(
                stage.status === StageStatus.CURRENT,
                index === 0,
                index === stages.length - 1,
                index,
                stages.length
              )}
            >
              {stage.status === StageStatus.CURRENT && stage.label}
            </div>
          ))}
        </div>
      ) : (
        currentStage && (
          <div
            className="current-stage-label"
            style={styling.currentStageLabel}
          >
            {currentStage.label}
          </div>
        )
      )}
      <div className="progress-container" style={styling.progressContainer}>
        {stages.map((stage, index) => {
          const isCompleted = stage.status === StageStatus.COMPLETED;
          const isCurrent = stage.status === StageStatus.CURRENT;
          let status = StageStatus.INCOMPLETE.toLowerCase();
          if (isCompleted) {
            status = StageStatus.COMPLETED.toLowerCase();
          } else if (isCurrent) {
            status = StageStatus.CURRENT.toLowerCase();
          }

          return (
            <div
              className="stage"
              style={styling.stageStyle(
                isCompleted,
                isCurrent,
                index < stages.length - 1
              )}
              key={stage.id}
              data-testid={`stagedProgressBarStep-${index}`}
              data-status={status}
            >
              <div className="icon-wrapper" style={styling.iconWrapper}>
                <div
                  className="step-icon"
                  style={styling.stepIcon(isCompleted, isCurrent)}
                  data-testid={`stagedProgressBarStepIcon-${index}`}
                  data-status={status}
                >
                  {stage.icon}
                </div>
                {index < stages.length - 1 && (
                  <div
                    className="connector"
                    data-testid={`stagedProgressBarConnector-${index}`}
                    style={styling.connector(
                      stage.status === StageStatus.COMPLETED
                    )}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StagedProgressBar;
